exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thank-you-comp .content{margin:auto;max-width:560px}", ""]);

// exports
